<template>
  <div class="component-body">
    <el-row>
      <el-col class="text-align-center margin-4 padding-8 color-ffffff" :span="4" v-for="(item,index) in defaultColor"
              :key="index">
        <div :style="{backgroundColor:item.color}" style="height: 60px;padding-top: 10px">
          <p>{{ item.name }}</p>
          <p>{{ item.color }}</p>
        </div>
        <div class="flex flex-between">
          <div style="flex:1;height:30px" v-for="(colorItem,index) in item.list" :key="index"
               :style="{backgroundColor:colorItem}">
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import generateColors from '@/utils/color'
import { getThemeColor } from '../../../../utils/common'

export default {
  name: 'color',
  props: {
    originalStyle: {
      type: String
    }
  },
  data () {
    return {
      defaultColor: [
        { name: 'Primary', color: '#409EFF', list: [] },
        { name: 'Success', color: '#67c23a', list: [] },
        { name: 'Warning', color: '#E6A23C', list: [] },
        { name: 'Danger', color: '#F56C6C', list: [] },
        { name: 'Info', color: '#909399', list: [] }
      ]
    }
  },
  created () {
    this.$watch('originalStyle', (newVal) => {
      if (newVal) {
        let colorObj = getThemeColor(newVal)
        this.defaultColor.forEach(item => {
          item.color = colorObj[item.name.toLowerCase()]
        })
      }
      this.getColor()
    }, { deep: true, immediate: true })
  },
  mounted () {
    this.getColor()
  },
  methods: {
    getColor () {
      this.defaultColor.forEach(item => {
        item.list = generateColors(item.color)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/1/Color/index.vue